import { FC } from "react";

import { Stack } from "@mui/material";

import { useTranslate } from "@/common/hooks/useTranslate";
import { DashboardTypography } from "@/dashboard-design-system/Typography";

interface RequestRefundDetailsProps {
  paymentLabel: string;
  amount: string;
  reasonLabel: string;
  organizationName: string;
}

export const RequestRefundDetails: FC<RequestRefundDetailsProps> = ({
  paymentLabel,
  amount,
  reasonLabel,
  organizationName,
}) => {
  const { t } = useTranslate();
  const rows = [
    { label: t("dashboard", "donorAssistant.approval.requestRefund.payment"), value: paymentLabel },
    { label: t("dashboard", "donorAssistant.approval.requestRefund.amount"), value: amount },
    { label: t("dashboard", "donorAssistant.approval.requestRefund.reason"), value: reasonLabel },
  ];
  return (
    <Stack spacing={1.5}>
      <Stack spacing={0.5}>
        {rows.map(({ label, value }) => (
          <Stack key={label} direction="row" justifyContent="space-between" spacing={2}>
            <DashboardTypography variant="body2" vibe="text-neutral-moderate">
              {label}
            </DashboardTypography>
            <DashboardTypography variant="subtitle2" vibe="text-neutral-intense" sx={{ textAlign: "right" }}>
              {value}
            </DashboardTypography>
          </Stack>
        ))}
      </Stack>
      <DashboardTypography variant="caption" vibe="text-neutral-moderate">
        {t("dashboard", "donorAssistant.approval.requestRefund.disclaimer", { organizationName })}
      </DashboardTypography>
    </Stack>
  );
};
